var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            title: _vm.$t("receivablePayable.ConfirmThePayableData"),
            visible: _vm.isBool,
            width: "50%",
            "close-on-press-escape": false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isBool = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.confirmLoading,
                  expression: "confirmLoading",
                },
              ],
              staticStyle: { height: "40vh", overflow: "hidden" },
            },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.batchNumber, border: "" } },
                [
                  _vm.payableType !== 5
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("login.siteName"),
                          prop: "siteName",
                        },
                      })
                    : _vm._e(),
                  _vm.payableType === 5
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("basicData.PayablePrincipal"),
                          prop: "providerName",
                        },
                      })
                    : _vm._e(),
                  _vm.payableType === 3
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("basicData.派送操作人"),
                          prop: "dispatcherName",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.dispatcherName.join("，")
                                      )
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1470674864
                        ),
                      })
                    : _vm._e(),
                  [4, 7].includes(_vm.payableType)
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("basicData.ExpenseType"),
                          prop: "feeCodeList",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(scope.row.feeName.join("，"))
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2217432593
                        ),
                      })
                    : _vm._e(),
                  _vm.payableType === 5
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("basicData.transportType"),
                          prop: "routeTypeName",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(scope.row.routeTypeName.join("，"))
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2367828662
                        ),
                      })
                    : _vm._e(),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("receivablePayable.TheNumberOfOrders"),
                      prop: "orderQty",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("receivablePayable.TheTotalAmountDue"),
                      prop: "totalAmount",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", disabled: _vm.confirmLoading },
                  on: {
                    click: function ($event) {
                      return _vm.determineGenerationFee(1)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("basicData.Cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _vm.confirmLoading,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.determineGenerationFee(2)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("basicData.determine")) + " ")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("receivablePayable.billHasBeenSuccess"),
            visible: _vm.showBillHasBeenSuccess,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showBillHasBeenSuccess = $event
            },
          },
        },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.batchTableData, border: "" } },
            [
              _vm.payableType !== 5
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("collectionCenter.siteName"),
                      prop: "siteName",
                      width: "160",
                    },
                  })
                : _vm._e(),
              _vm.payableType === 5
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("basicData.PayablePrincipal"),
                      prop: "providerName",
                      width: "160",
                    },
                  })
                : _vm._e(),
              _vm.payableType === 3
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("basicData.派送操作人"),
                      prop: "dispatcherName",
                      width: "160",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                _vm._v(
                                  _vm._s(scope.row.dispatcherName.join("，"))
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1470674864
                    ),
                  })
                : _vm._e(),
              [4, 7].includes(_vm.payableType)
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("basicData.ExpenseType"),
                      prop: "feeCodeList",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                _vm._v(_vm._s(scope.row.feeName.join("，"))),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2217432593
                    ),
                  })
                : _vm._e(),
              _vm.payableType === 5
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("basicData.transportType"),
                      prop: "routeTypeName",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                _vm._v(
                                  _vm._s(scope.row.routeTypeName.join("，"))
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2367828662
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("receivablePayable.TheNumberOfOrders"),
                  prop: "orderQty",
                  width: "160",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("receivablePayable.TheTotalAmountDue"),
                  prop: "totalAmount",
                  width: "160",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("receivablePayable.BillingBatchNumber"),
                  prop: "billBatchNumbers",
                  width: "260",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.billBatchNumbers &&
                        scope.row.billBatchNumbers.length > 0
                          ? _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    scope.row.billBatchNumbers.join("，")
                                  ) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.ReasonForAbnormal"),
                  prop: "failureReason",
                  width: "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.operation"),
                  width: "180",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.billBatchNumbers &&
                        scope.row.billBatchNumbers.length > 0
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  size: "small",
                                  plain: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.copyBatchNumber(
                                      scope.row.billBatchNumbers
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "receivablePayable.CopyTheBatchNumber"
                                    )
                                  )
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }